import React, {useEffect, useState} from 'react';
import {useSelector} from "react-redux";
import {Button, Empty, Flex, message, Modal, Table} from "antd";
import IntlMessage from "../../../../../components/IntlMessage/IntlMessage";
import classes from "../../Applications/application.module.css";
import CertificateService from "../../../../../services/CertificateService";
import MyText from "../../../../../components/UI/Text/MyText";
import {Document, Page} from "react-pdf";
import {API_BASE_URL} from "../../../../../constants/api";
import GreyButton from "../../../../../components/UI/Buttons/GreyButton";

const StudentCertificatesList = () => {
    const {user, isLoading} = useSelector(state => state.user);

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(100);

    const [initialLoading, setInitialLoading] = useState(true);

    const [certificates, setCertificates] = useState([])

    const [viewCertificate, setViewCertificate] = useState(false)
    const [openViewCertificate, setOpenViewCertificate] = useState(false)
    const [certificateNumPages, setCertificateNumPages] = useState();
    const [certificatePageNumber, setCertificatePageNumber] = useState(1);


    useEffect(() => {
        if (!isLoading) {
            setInitialLoading(true);
            fetchData();
        }
    }, []);

    async function fetchData() {
        await CertificateService.getCertificatesByIIN(user?.profile?.iin)
            .then((r) => {
                message.success(<IntlMessage id={'success'}/>, 5);
                setCertificates(r.data)
            })
            .catch(() => {
                message.destroy();
                message.error(<IntlMessage id={'error'}/>, 5);
            })
            .finally(() => {
                setInitialLoading(false);
                message.destroy();
            })
    }

    const columns = [
        {
            title: <IntlMessage id={'certificate.code'}/>,
            render: (_, record) => (
                <p>{record.code}</p>
            ),
            width: '10%',
        },
        {
            title: <IntlMessage id={'certificate.issueDate'}/>,
            render: (_, record) => (
                <p>{new Date(record.date).toLocaleDateString()}</p>
            ),
            width: '10%',
        },

        {
            title: <IntlMessage id={'certificate.expirationDate'}/>,
            render: (_, record) => (
                <p>{new Date(record.expirationDate).toLocaleDateString()}</p>
            ),
            width: '10%',
        },
        {
            title: <IntlMessage id={'actions'}/>,
            render: (_, record) => (
                <>
                    {
                        <Flex style={{width: "100%"}} align={"center"} justify={"center"} wrap={"wrap"} gap={20}>
                            <p onClick={() => {
                                setViewCertificate(record);
                                setOpenViewCertificate(true);
                            }} className={classes.copyLinkBtn}><IntlMessage id={'view'}/></p>
                            <p onClick={() => downloadDocument(record?.id, record)}
                               className={classes.copyLinkBtn}><IntlMessage id={'download'}/></p>

                        </Flex>
                    }
                </>
            ),
            width: '10%',
        },
    ];

    const handlePaginationChange = (page, pageSize) => {
        setCurrentPage(page);
        setPageSize(pageSize);
    }

    function onDocumentLoadSuccess({numPages}: { numPages: number }): void {
        setCertificateNumPages(numPages);
    }

    function triggerDownload(blob, filename) {
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename); // Set the download attribute with a filename
        document.body.appendChild(link);
        link.click();

        // Clean up and revoke the URL after download
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    }

    async function downloadDocument(documentId, certificate) {
        message.loading(<IntlMessage id={'loading'}/>, 0);
        // await CertificateService.getTestResourceById()
        await CertificateService.getResourceById(certificate?.code)
            .then((r) => {
                message.destroy();
                message.success(<IntlMessage id={'success'}/>, 5);

                triggerDownload(r.data, certificate?.certificateTemplate?.name + " Certificate.pdf")
            })
            .catch(() => {
                message.destroy();
                message.error(<IntlMessage id={'error'}/>, 5);
            })
    }

    return (
        <Flex style={{width: "100%"}} align={"flex-start"} justify={"flex-start"} gap={20} vertical>
            <MyText uppercase strong
                    size={"large"}><IntlMessage id={"certificates"}/></MyText>
            <Table
                bordered
                columns={columns}
                dataSource={certificates}
                loading={initialLoading}
                style={{
                    width: "100%",
                }}
                scroll={{x: 800}}
                locale={{emptyText: <Empty description={<IntlMessage id={"noData"}/>}></Empty>}}
            />
            <Modal
                width={800}
                maskClosable={true}
                // title={<IntlMessage id={'contractsPage.details'}/>}
                open={openViewCertificate}
                okText={<IntlMessage id={'save'}/>}
                cancelText={<IntlMessage id={'close'}/>}
                style={{
                    top: 20,
                }}
                onOk={() => {
                    setOpenViewCertificate(false)
                }}
                onCancel={() => {
                    setOpenViewCertificate(false)
                }}
                footer={[
                    <Button key="submit" type="primary" onClick={() => {
                        setOpenViewCertificate(false)
                    }}>
                        OK
                    </Button>
                ]}
            >
                {
                    viewCertificate &&
                    <Flex gap={50}
                          style={{
                              width: "100%",
                              minHeight: "calc(100vh - 300px)",
                              position: "relative",
                              padding: "0px 20px 20px 0px",
                          }}
                          vertical
                          align={"flex-start"}
                          justify={"flex-start"}>
                        <Flex align={"center"} justify={"center"} vertical
                              style={{overflowX: "auto", overflowY: "hidden", width: "100%"}}>
                            <Flex style={{
                                zIndex: 1,
                                padding: "10px 20px",
                                backgroundColor: "white",
                                borderRadius: 10,
                                boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.1)",
                            }} gap={15} justify={"space-between"} align={"center"}>
                                <Button disabled={certificatePageNumber === 1} onClick={() => {
                                    setCertificatePageNumber(certificatePageNumber - 1)
                                }}>
                                    {'<'}
                                </Button>
                                <MyText size={"small"}>
                                    {certificatePageNumber} / {certificateNumPages}
                                </MyText>
                                <Button disabled={certificatePageNumber === certificateNumPages} onClick={() => {
                                    setCertificatePageNumber(certificatePageNumber + 1)
                                }}>
                                    {'>'}
                                </Button>
                            </Flex>
                            <Document file={API_BASE_URL + "/api/certificate/resource/code/" + viewCertificate?.code}
                                      onLoadSuccess={onDocumentLoadSuccess}
                                      loading={<IntlMessage id={'documentIsLoading'}/>}
                            >
                                <Page pageNumber={certificatePageNumber} width={700}/>
                            </Document>
                        </Flex>
                        <Flex align={"flex-start"} justify={"center"} gap={20} style={{width: "100%"}}>
                            <GreyButton onClick={() => downloadDocument(viewCertificate?.id, viewCertificate)}>
                                <IntlMessage id={'download'}/>
                            </GreyButton>
                        </Flex>
                    </Flex>
                }
            </Modal>
        </Flex>
    );
};

export default StudentCertificatesList;